<template>
  <div class="main-container">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <!-- Title-area -->
    <b-row class="d-flex align-items-center mx-auto py-3">
      <span class="title-header">パスワード</span>
    </b-row>
    <!-- Content-area -->
    <validation-observer v-slot="{ handleSubmit }" class="w-100">
      <b-form class="submit-form" @submit.prevent="handleSubmit(doSave)">
        <b-container fluid class="profile-area card_wrap d-flex flex-column">
          <h5 class="justify-content-start mt-3 ml-3 content-title">
            パスワード変更
          </h5>
          <!-- CHANGE PASSWORD -->
          <b-row class="mt-2 change-password">
            <label for="new-password-input" class="row-title">新しいパスワード</label>
            <b-col>
              <ValidationProvider
                name="新しいパスワード"
                mode="passive"
                :rules="{
                  required: true,
                  password: true
                }"
                v-slot="{ errors }"
              >
                <b-form-input
                  ref="passwordRef"
                  id="new-password-input"
                  type="password"
                  v-model="changedPassword"
                  v-bind:class="
                    errors[0]
                      ? 'border border-danger bg-danger-outline'
                      : ''
                  "
                  maxlength="20"
                ></b-form-input>
                <span class="text-danger" v-for="(error, i) in errors" :key="i"
                  >{{ errors[i] }}
                </span>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row>
            <p class="row-title"></p>
            <b-col>
              <p class="tooltip-label mb-2 mt-0 pl-2">
                半角の英字、数字を含む6～20文字
                <span class="character-counting">{{
                  charactersRemaining
                }}</span>
              </p>
            </b-col>
          </b-row>

          <!-- CONFIRM PASSWORD AREA -->
          <b-row class="mb-3 change-password">
            <label for="confirm-password-input" class="row-title">確認入力</label>
            <b-col>
              <ValidationProvider
                mode="passive"
                name="確認入力"
                class="mb-2"
                :rules="{
                  confirmedPass:changedPassword,
                }"
                v-slot="{ errors }">
                <b-form-input
                  id="confirm-password-input"
                  type="password"
                  v-model="confirmPassword"
                  v-bind:class="
                    errors[0] || confirmedErrorMsg
                      ? 'border border-danger bg-danger-outline'
                      : ''
                  "
                  maxlength="20"
                ></b-form-input>
                <span class="text-danger" v-for="(error, i) in errors" :key="i"
                  >{{ errors[i] }}
                </span>
                <span class="text-danger">{{ errors[0] ? '' : confirmedErrorMsg }} </span>
              </ValidationProvider>
            </b-col>
          </b-row>
        </b-container>
        <!-- Submit-area -->
        <b-container
          fluid
          class="d-flex align-items-center justify-content-center mt-3"
        >
          <b-button type="submit" class="btn_blue">保存</b-button>
        </b-container>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { userService } from '../../_services/user.service'
import FlashMessage from '../../common/flash-message.component'
import Loading from 'vue-loading-overlay'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Loading
  },
  data() {
    return {
      changedPassword: '',
      confirmPassword: '',
      confirmedErrorMsg: null,
      isLoading: false,
      standardPasswordRegex: /^(?=.*[a-zA-Z])(?=.*[0-9]).*$/,
      fullWidthRegex:
        // eslint-disable-next-line no-useless-escape
        /[^a-zA-Z0-9\s\!\?\@\#\$\%\^\&\*\)\(+\=\.\:\/\\\[\]\{\}\,\|\"`~_<>;'-]/
    }
  },
  computed: {
    charactersRemaining() {
      return `${this.changedPassword.length}/20`
    }
  },
  methods: {
    ...mapActions('checkPassword', ['checkUserId']),
    ...mapGetters('auth', ['getIsSystemSessionStorageLogin']),
    async doSave() {
      this.confirmedErrorMsg = null
      if (!this.confirmPassword) {
        this.confirmedErrorMsg = '新しいパスワードと一致しません。'
        return
      }
      this.isLoading = true
      // Fetch RESET PASSWORD API
      await userService.resetPassword(this.confirmPassword).catch((error) => {
        this.isLoading = false
        return error
      })
      const plusaUser = this.getIsSystemSessionStorageLogin() ? JSON.parse(sessionStorage.getItem('plusa-user')) : JSON.parse(localStorage.getItem('plusa-user'))
      const userResetPassword = {
        userId: plusaUser.userId,
        changePasswordFlag: false
      }
      this.checkUserId(userResetPassword)
      FlashMessage.getInstance().showSuccessMessage(
        'パスワードを変更しました。'
      )
      this.changedPassword = ''
      this.confirmPassword = ''
      this.isLoading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.main-container {
  @include responsive-fs(16);
  .change-password {
    align-items: center;
  }
  .row-title {
    font-weight: bold;
    @include responsive-fs(16);
    color: #666563;
    padding-left: 63px;
    width: 302px;
  }
  .title-header {
    font-weight: bold;
    @include responsive-fs(24);
  }
  .content-title {
    font-weight: bold;
    @include responsive-fs(20);
  }
  .tooltip-label {
    font-weight: normal;
    @include responsive-fs(14);
    color: #666563;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user-info/ChangePassword.vue